import { z } from 'zod';

export const connectionStatuses = [
  'ACTIVE',
  'INACTIVE',
  'MAINTENANCE',
] as const;

export const ConnectionStatusSchema = z.enum(connectionStatuses);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;

const ConnectionAddressSchema = z.object({
  countyCode: z.string(),
  postcode: z.string(),
  fullAddress: z.string(),
});

export const ConnectionSchema = z.object({
  id: z.string(),
  authorityId: z.string(),
  authorityName: z.string(),
  serviceSchemeId: z.string(),
  serviceSchemeName: z.string(),
  name: z.string(),
  address: ConnectionAddressSchema,
  location: z.string(),
  guid: z.string(),
  status: ConnectionStatusSchema,
  createDate: z.string(),
  lastUpdateDate: z.string(),
  type: z.string(),
  phoneNumber: z.string(),
});

export type Connection = z.infer<typeof ConnectionSchema>;

export const ConnectionListItemSchema = ConnectionSchema.omit({
  type: true,
  phoneNumber: true,
});
export type ConnectionListItem = z.infer<typeof ConnectionListItemSchema>;
